import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class LegalObligationTemplate extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'legalobligation/templates',
            id: this.props.Id,
            loading: true,
            lockScreen: 0,
            services: [],
            record: {
                id: 0,
                title: '',
                description: '',
                serviceId: null,
                customerType: null,
                periodType: 1,   
                dueDayOffset: 15,
                priority: 2,    
                isActive: true,
                dueDayRule: '', 
            },
            data:null
        };
    }

    componentDidMount() { this.loadData(); }

    async loadData() {
        const currentId = this.getCurrentFormId();
        this.httpPost(`api/v1/${this.state.controllerName}/get`, { id: currentId })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        record: data.record,
                        services: data.services,
                        loading: false,
                        data:data
                    });
                } else if (data.status === -5) window.location.href = "/access-denied"; else {
                    this.showErorrMessage(data.message);
                    this.setState({ loading: false });
                }
            });
    }

    handleChange(field, value) {
        this.setState({ record: { ...this.state.record, [field]: value } });
    }

    async save(e) {
        e.preventDefault();
        this.setState({ lockScreen: 1 });
        this.httpPost(`api/v1/${this.state.controllerName}/save`, this.state.record)
            .then(data => {
                this.setState({ lockScreen: 0 });
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage('قالب ذخیره شد');
                    this.setState({ redirect: '/legalobligationtemplates' });
                } else {
                    this.showErorrMessage(data.message);
                }
            });
    }

    renderForm() {
        const { record, services } = this.state;
        const isEdit = record.id > 0;
        return (
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">{isEdit ? 'ویرایش قالب' : 'افزودن قالب جدید'}</h3>
                        </div>
                        <div className="nk-block-head-content">
                            <NavLink to="/legalobligationtemplates/" className="btn btn-dim btn-outline-light"><em className="icon ni ni-arrow-left"></em><span>بازگشت</span></NavLink>
                        </div>
                    </div>
                </div>

                <div className="nk-block">
                    <div className="card card-bordered">
                        <div className="card-inner">
                            <form onSubmit={e => this.save(e)}>
                                <div className="row g-4">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label className="form-label">عنوان <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" value={record.title}
                                                onChange={e => this.handleChange('title', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label className="form-label">سرویس مرتبط</label>
                                            <select className="form-select" value={record.serviceId || ''}
                                                onChange={e => this.handleChange('serviceId', e.target.value ? parseInt(e.target.value) : null)}>
                                                <option value="">-- بدون سرویس --</option>
                                                {services.map(s => <option key={s.id} value={s.id}>{s.title}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label className="form-label">نوع مشتری</label>
                                            <select className="form-select" value={record.customerType || ''}
                                                onChange={e => this.handleChange('customerType', e.target.value ? parseInt(e.target.value) : null)}>
                                                <option value="">همه</option>
                                                <option value="1">حقیقی</option>
                                                <option value="2">حقوقی</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label className="form-label">نوع دوره</label>
                                            <select className="form-select" value={record.periodType}
                                                onChange={e => this.handleChange('periodType', parseInt(e.target.value))}>
                                                <option value="1">ماهانه</option>
                                                <option value="2">فصلی</option>
                                                <option value="3">سالانه</option>
                                                <option value="4">روزانه</option>
                                                <option value="5">تاریخ ثابت</option>
                                                <option value="6">هفتگی</option>
                                            </select>
                                        </div>
                                    </div>
                                    {record.periodType !== 5 && (
                                        <>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">قاعده سررسید</label>
                                                    <input type="text" className="form-control"
                                                        value={record.dueDayRule}
                                                        onChange={e => this.handleChange('dueDayRule', e.target.value)}
                                                        placeholder="مثلاً 15 روز پس از پایان دوره" />
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">موعد (روز پس از پایان دوره)</label>
                                                    <input type="number" className="form-control" value={record.dueDayOffset}
                                                        onChange={e => this.handleChange('dueDayOffset', parseInt(e.target.value))} />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">اولویت</label>
                                            <select className="form-select" value={record.priority}
                                                onChange={e => this.handleChange('priority', parseInt(e.target.value))}>
                                                <option value="1">کم</option>
                                                <option value="2">متوسط</option>
                                                <option value="3">زیاد</option>
                                                <option value="4">حیاتی</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">وضعیت</label>
                                            <select className="form-select" value={record.isActive ? '1' : '0'}
                                                onChange={e => this.handleChange('isActive', e.target.value === '1')}>
                                                <option value="1">فعال</option>
                                                <option value="0">غیرفعال</option>
                                            </select>
                                        </div>
                                    </div>
                                    {record.periodType === 5 && (
                                        <>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">ماه</label>
                                                    <select className="form-select" value={record.dueMonth || ''}
                                                        onChange={e => this.handleChange('dueMonth', e.target.value ? parseInt(e.target.value) : null)}>
                                                        <option value="">-- انتخاب --</option>
                                                        {['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'].map((m, idx) => (
                                                            <option key={idx + 1} value={idx + 1}>{m}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">روز</label>
                                                    <input type="number" className="form-control" value={record.dueDay || ''}
                                                        onChange={e => this.handleChange('dueDay', e.target.value ? parseInt(e.target.value) : null)}
                                                        min="1" max="31" />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label className="form-label">توضیحات</label>
                                            <textarea className="form-control" rows="3" value={record.description}
                                                onChange={e => this.handleChange('description', e.target.value)}></textarea>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <button type="submit" className="btn btn-primary" disabled={this.state.lockScreen === 1}>
                                            <em className="icon ni ni-save"></em> ذخیره
                                        </button>
                                        <NavLink to="/legalobligationtemplates/" className="btn btn-dim btn-outline-light ms-2"><em className="icon ni ni-cross"></em> انصراف</NavLink>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;
        let contents = this.state.loading ? this.renderLoading() : [
            this.state.lockScreen === 1 && this.lockScreen(),
            <Header data={{ global: this.state.data?.global }} />,
            <div className="nk-content "><div className="container-fluid"><div className="nk-content-inner">{this.renderForm()}</div></div></div>,
            <Footer />
        ];
        return contents;
    }
}